// client/src/components/ai/useGeracaoIAGate.js
// Gate de plano+permissão pro botão "Gerar com IA" — mesmo raciocínio de
// useHomePersonalizadaGate.js (siteInstitucional): matriz nunca é
// bloqueada (não existe "plano da matriz"); conta/franquia sem a feature
// 'hasGeracaoIA' no plano não veem o botão. A permissão 'ai_geracao:use'
// (concedida automaticamente a *_admin:full_access) cobre o caso de um
// papel customizado dentro de uma conta que TEM o plano mas não deveria
// deixar todo usuário gerar conteúdo por IA.
import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import useContaPlan from '../../hooks/useContaPlan';
import useFranquiaPlan from '../../hooks/useFranquiaPlan';

export function useGeracaoIAGate() {
    const { scope: userScope, hasPermission } = useAuth();
    const contaPlan = useContaPlan();
    const franquiaPlan = useFranquiaPlan();

    const planPermiteIA = userScope === 'matriz'
        ? true
        : userScope === 'franquia'
            ? franquiaPlan.hasFeature('hasGeracaoIA')
            : contaPlan.hasFeature('hasGeracaoIA');

    const temPermissaoIA = hasPermission('ai_geracao:use');

    return { podeGerarComIA: planPermiteIA && temPermissaoIA, planPermiteIA, temPermissaoIA, userScope };
}

// Mostrado no lugar do botão/caixa de IA quando o gate bloqueia — mensagem
// varia conforme o motivo (plano vs. permissão) pra não mandar todo mundo
// pra tela de planos quando na verdade falta é o admin da conta liberar a
// permissão pro papel do usuário.
export function GeracaoIAUpsellBanner({ planPermiteIA }) {
    if (!planPermiteIA) {
        return (
            <div className="content-panel mb-4" style={{ borderLeft: '4px solid #7c3aed', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Sparkles size={20} style={{ flexShrink: 0, color: '#7c3aed' }} />
                <div>
                    <strong>Geração de conteúdo por IA disponível a partir de um plano superior.</strong>
                    <p className="text-sm text-gray-500" style={{ margin: 0 }}>
                        Faça upgrade do seu plano para gerar textos e imagens automaticamente com IA.
                    </p>
                </div>
                <Link to="/assinatura?reason=feature" className="action-button action-button-primary" style={{ marginLeft: 'auto', whiteSpace: 'nowrap' }}>
                    Ver planos
                </Link>
            </div>
        );
    }
    return (
        <div className="content-panel mb-4" style={{ borderLeft: '4px solid #7c3aed', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Sparkles size={20} style={{ flexShrink: 0, color: '#7c3aed' }} />
            <div>
                <strong>Geração de conteúdo por IA não liberada para o seu usuário.</strong>
                <p className="text-sm text-gray-500" style={{ margin: 0 }}>
                    Peça para um administrador liberar a permissão "Gerar texto/imagem por IA" no seu papel de acesso.
                </p>
            </div>
        </div>
    );
}
